export var VERSION = '1.18.3';
//# sourceMappingURL=version.js.map